// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  AI_PROMPT_BUILDER_UPDATE_LINKING_TO_UUID_BEGIN,
  AI_PROMPT_BUILDER_UPDATE_LINKING_TO_UUID_DISMISS_ERROR,
  AI_PROMPT_BUILDER_UPDATE_LINKING_TO_UUID_FAILURE,
  AI_PROMPT_BUILDER_UPDATE_LINKING_TO_UUID_SUCCESS,
} from './constants';

export function updateLinkingToUuid(args = {}) {
  return (dispatch) => {
    dispatch({
      type: AI_PROMPT_BUILDER_UPDATE_LINKING_TO_UUID_BEGIN,
    });

    const { projectId,version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const body = {"projectId":projectId}
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/pages/update-linking-to-uuid`,
        body,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: AI_PROMPT_BUILDER_UPDATE_LINKING_TO_UUID_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: AI_PROMPT_BUILDER_UPDATE_LINKING_TO_UUID_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });
    return promise;
  };
}

export function dismissUpdateLinkingToUuidError() {
  return {
    type: AI_PROMPT_BUILDER_UPDATE_LINKING_TO_UUID_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case AI_PROMPT_BUILDER_UPDATE_LINKING_TO_UUID_BEGIN:
      return {
        ...state,
        updateLinkingToUuidPending: true,
        updateLinkingToUuidError: null,
      };

    case AI_PROMPT_BUILDER_UPDATE_LINKING_TO_UUID_SUCCESS:
      return {
        ...state,
        updateLinkingToUuidPending: false,
        updateLinkingToUuidError: null,
      };
    case AI_PROMPT_BUILDER_UPDATE_LINKING_TO_UUID_FAILURE:
      return {
        ...state,
        updateLinkingToUuidPending: false,
        updateLinkingToUuidError: action.data.error,
      };

    case AI_PROMPT_BUILDER_UPDATE_LINKING_TO_UUID_DISMISS_ERROR:
      return {
        ...state,
        createAppError: null,
      };

    default:
      return state;
  }
}
